import DragDrop from "../DragDrop";
import ICustomFormSettings from "../../ICustomFormSettings";
import m, {VnodeDOM} from "mithril";
import DragCell from "../../shared/components/FormCell/DragCell";
import {ComboItem} from "../../../model/items/combo";
import Sortable from 'sortablejs';
import {LabelItem} from "../../../model/items/labelItem";
import {simpleContent} from "../../../ui/items/helpers";
import {ImageItem} from "../../../model/items/imageItem";
import Image from "../../shared/components/Image/Image";
import {OptionItem} from "../../../model/options";
import {CheckboxItem} from "../../../model/items/checkbox";
import CheckboxCell from "../../shared/components/FormCell/CheckboxCell";

export default class DragDropSorting extends DragDrop {

	private sortableComponent: Sortable|null = null;

	private readonly optionsValues: string[] = [];
	private readonly topLabel: LabelItem|null = null;
	private readonly bottomLabel: LabelItem|null = null;
	private readonly combos: ComboItem[];
	private readonly checkboxes: CheckboxCell[] = [];

	constructor(settings: ICustomFormSettings) {
		super(settings);

		// Unset wrong hero image (set it later)
		this.heroImage = undefined;

		// Load labels, images, combos
		const labels: LabelItem[] = [],
			images: ImageItem[] = [],
			combos: ComboItem[] = [],
			layout = this.settings.form.grid.layout;
		layout.forEach(row => {
			row.forEach(cell => {
				cell.cellItems.forEach(cellItem => {
					if (cellItem instanceof ImageItem) {
						images[cell.row] = cellItem;
					} else if (cellItem instanceof LabelItem) {
						labels[cell.row] = cellItem;
					} else if (cellItem instanceof ComboItem) {
						combos[cell.row] = cellItem;
					} else if (cellItem instanceof CheckboxItem) {
						this.checkboxes.push( new CheckboxCell(
							cell,
							(ci, v) => {
								this.onSetValue(ci, v);
							},
						));
					}
				});
			});
		});
		this.combos = combos;

		// Set sorting labels and hero image
		if (!combos[0]) {
			if (images[0]) {
				this.heroImage = new Image(images[0]);
			}
			if (labels[0]) {
				this.topLabel = labels[0];
			}
		}
		const lastRowIndex = layout.length - 1;
		if (!combos[lastRowIndex]) {
			if (images[lastRowIndex]) {
				this.heroImage = new Image(images[lastRowIndex]);
			}
			if (labels[lastRowIndex]) {
				this.bottomLabel = labels[lastRowIndex];
			}
		}

		// Compose drag cells with options
		let options: undefined|OptionItem[];
		for (const i in combos) {
			if (combos[i] && labels[i]) {
				// Draggable items
				this.dragCells[i] = new DragCell(combos[i], labels[i], images[i]);
				options = this.dragCells[i].combo.getOptions();
			}
		}

		options?.forEach(option => option.value ? this.optionsValues.push(option.value) : undefined);
	}

	public checkRequirements(): boolean {
		if (this.dragCells.length === 0) {
			console.log('customForm-DragDrop-sorting: There are no items to sort');
			return false;
		}

		if (this.optionsValues.length < this.dragCells.filter(c => Boolean(c)).length) {
			console.log(`customForm-DragDrop-sorting: Not enough combo box values to sort items (minimum is ${this.optionsValues.length}, got ${this.dragCells.length})`);
			return false;
		}

		return true;
	}

	public view() {
		const form = this.settings.form;
		const randomization = form.questionary.state.random.form[form.id];

		const cells = [];
		for (let ri in this.dragCells) {
			const i = randomization ? randomization.rows[ri] : ri;
			if (this.dragCells[i].combo.cell.visible) {
				cells.push(m(this.dragCells[i]));
			}
		}

		return this.viewLayout(
			m("form", {}, [
				this.viewHeroVideo(),
				this.viewHeroImage(),
				this.topLabel ? m('label', simpleContent(this.topLabel, this.topLabel.childrenTags)) : null,
				m('.sortable', {}, cells),
				this.bottomLabel ? m('label', simpleContent(this.bottomLabel, this.bottomLabel.childrenTags)) : null,
				...this.checkboxes.map(ch => m(ch)),
			])
		);

	};


	//------------//
	// HANDLERS
	private onStoreGet(): string[] {
		const variables = [];
		for(const i in this.dragCells) {
			const dragCell = this.dragCells[i];
			variables.push({
				value: dragCell.combo.getVariable(),
				variableName: dragCell.combo.variableName,
			});
		}
		variables.sort((a, b) => {
			if (a.value === undefined || b.value === undefined) return 0;
			return (Number(a.value) > Number(b.value)) ? 1 : -1;
		});
		return variables.map(item => item.variableName);
	}

	private onStoreSet(sortable: Sortable): void {
		let i = 0;
		for (const variableName of sortable.toArray()) {
			this.setVariable(variableName, this.optionsValues[i++]);
		}
		for (const i in this.combos) {
			this.onSetValue(this.combos[i], this.combos[i].getVariable());
		}
        this.settings.form.questionary.eventReporter?.report(
            'CF_DRAG_DROP_SORTING_SET',
            {
                formId: this.settings.form.id,
                order: sortable.toArray(),
            }
        );
	}

	oncreate(vnode: VnodeDOM) {
		super.oncreate(vnode);
		this.sortableComponent = new Sortable($(vnode.dom).find('.sortable')[0], {
			store: {
				get: this.onStoreGet.bind(this),
				set: this.onStoreSet.bind(this),
			},
			//handle: '.handle',
			animation: 150,
		});
	}

}
